import { render, staticRenderFns } from "./OrderServiceCreateUpdate.vue?vue&type=template&id=0c92394e&"
import script from "./OrderServiceCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./OrderServiceCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports